// extracted by mini-css-extract-plugin
export var button = "_aw-7";
export var buttonRow = "_aw-6";
export var fadeIn = "_aw-1";
export var gradient = "_aw-0";
export var panel = "_aw-2";
export var panelIn = "_aw-3";
export var subtitle = "_aw-5";
export var title = "_aw-4";